import { itensRegularizacaoContaResumoStyles } from './ItensRegularizacaoContaResumo.style'

export function itensRegularizacaoContaResumoIO() {
  return {
    styles: itensRegularizacaoContaResumoStyles
  }
}

export type ItensRegularizacaoContaResumoIO = ReturnType<typeof itensRegularizacaoContaResumoIO>
